// import { /*Flyout,*/ HorizontalFlyout, Options, /*Options,*/ utils, /*MetricsManager*/ } from 'blockly/core';
import * as Blockly from 'blockly/core';
import { VmtFieldFlyoutText } from './VmtFlyoutEditField';
// import { FlyoutItem } from 'blockly/core/flyout_base';

// export class VmtFlyout extends Blockly.HorizontalFlyout {
export class VmtFlyout extends Blockly.VerticalFlyout {
    /**
     * Override flyout factor to be smaller for flydowns.
     * @type {number}
     * @const
     */
    VERTICAL_SEPARATION_FACTOR = 1;
    // static get VERTICAL_SEPARATION_FACTOR() { return 1 }

    /** @param {Blockly.Options} workspaceOptions Dictionary of options for the workspace. */
    // eslint-disable-next-line no-useless-constructor
    constructor(workspaceOptions) {
        super(workspaceOptions);
        this.dragAngleRange_ = 360;
    }


    /**
     * Initialize the flyout.
     * @param {Blockly.Workspace} workspace 
     */
    init(workspace) {
        super.init(workspace);
        // this.workspace_.addChangeListener(this.onWorkspaceChange_.bind(this));
        this.workspace_.setTheme(workspace.getTheme());
        // workspace.getComponentManager().addCapability(this.id,
        //     Blockly.ComponentManager.Capability.AUTOHIDEABLE);
    }

    /**
     * 
     * @param {string | utils.Svg<SVGSVGElement> | utils.Svg<SVGGElement>} tagName 
     * @returns {SVGElement}
     * @override
     */
    createDom(tagName) {
        const cssClassName = 'vmtFlyout';
        this.svgGroup_ = Blockly.utils.dom.createSvgElement(Blockly.utils.Svg.G, { 'class': cssClassName }, this.svgGroup_);
        this.svgBackground_ = Blockly.utils.dom.createSvgElement(Blockly.utils.Svg.PATH, {
            'stroke': '#fff', //backgroundCOLOR,
            'stroke-width': 2,
            // 'fill': '#ADD8E6AA',//backgroundCOLOR
            'fill': '#ADD8E6',//backgroundCOLOR
            'fill-opacity': 0.8,
        }, this.svgGroup_);
        this.svgGroup_.appendChild(this.workspace_.createDom());
        return this.svgGroup_;
    }

    /**
     * 
     * @override
     */
    position() {
        return;
        // if (!this.isVisible()) {
        //     return;
        // }

        // const metrics = this.getMetrics_();
        // if (!metrics) {
        //     return;
        // }

        // // Custom positioning logic
        // // const edgeWidth = this.horizontalLayout_ ? metrics.viewWidth : metrics.viewHeight;
        // // const flyoutWidth = this.horizontalLayout_ ? this.width_ : this.height_;
        // // const x = metrics.absoluteLeft + edgeWidth - flyoutWidth;
        // // const y = metrics.absoluteTop;
        // const x = metrics.top;
        // const y = metrics.left;

        // this.positionAt_(x, y);
    }

    // /**
    //  * 
    //  * @param {number} x 
    //  * @param {number} y
    //  * @protected 
    //  */
    // positionAt_(x, y) {
    //     this.svgGroup_?.setAttribute('transform', `translate(${x}, ${y})`);
    // }

    /**
     * Show and populate the flyout.
     * @param {!Array|string} xmlList List of blocks to show.
     * @param {!number} x X-position of upper-left corner of flydown.
     * @param {!number} y Y-position of upper-left corner of flydown.
     */
    showAt(xmlList, x, y) {
        Blockly.Events.disable();
        try {
            // invoke flyout method, which adds blocks to flydown
            // and calculates width and height.
            this.show(xmlList);
        } finally {
            Blockly.Events.enable();
        }
        // this.svgGroup_.setAttribute('transform', 'translate(' + x + ',' + y +
        // ')');
        // Calculate path around flydown blocks. Based on code in flyout position_
        // method.

        // Start at bottom of top left arc and proceed clockwise
        // Flydown outline shape is symmetric about vertical axis, so no need to
        // differentiate LTR and RTL paths.
        const margin = this.CORNER_RADIUS * this.workspace_.scale;
        const edgeWidth = this.width_ - 2 * margin;
        const edgeHeight = this.height_ - 2 * margin;
        const path = ['M 0,' + margin];
        path.push('a', margin, margin, 0, 0, 1, margin, -margin); // upper left arc
        path.push('h', edgeWidth); // top edge
        path.push('a', margin, margin, 0, 0, 1, margin, margin); // upper right arc
        path.push('v', edgeHeight); // right edge
        path.push('a', margin, margin, 0, 0, 1, -margin, margin); // bottom right arc
        path.push('h', -edgeWidth); // bottom edge, drawn backwards
        path.push('a', margin, margin, 0, 0, 1, -margin, -margin); // bottom left arc
        path.push('z'); // complete path by drawing left edge
        this.svgBackground_.setAttribute('d', path.join(' '));
        this.svgGroup_.setAttribute('transform', `translate(${x}, ${y})`);
    }

    /**
     * @protected
     * @override
     */
    reflowInternal_() {
        this.workspace_.scale = this.targetWorkspace.scale;
        const scale = this.workspace_.scale;
        let flydownWidth = 0;
        let flydownHeight = 0;
        const margin = this.CORNER_RADIUS * scale;
        const blocks = this.workspace_.getTopBlocks(false);
        // for (let i = 0, block; block = blocks[i]; i++) {
        blocks.forEach(block => {
            const blockHW = block.getHeightWidth();
            flydownWidth = Math.max(flydownWidth, blockHW.width * scale);
            flydownHeight += blockHW.height * scale;
        });
        flydownWidth += 2 * margin + this.tabWidth_ * scale; // tabWidth is width of
        // a plug
        const rendererConstants = this.workspace_.getRenderer().getConstants();
        const startHatHeight = rendererConstants.ADD_START_HATS ?
            rendererConstants.START_HAT_HEIGHT : 0;
        flydownHeight += 3 * margin +
            margin * this.VERTICAL_SEPARATION_FACTOR * (blocks.length) +
            startHatHeight * scale / 2.0;
        if (this.width_ !== flydownWidth) {
            // for (let j = 0, block; block = blocks[j]; j++) {
            blocks.forEach(block => {
                const blockHW = block.getHeightWidth();
                const blockXY = block.getRelativeToSurfaceXY();
                if (this.RTL) {
                    // With the FlydownWidth known, right-align the blocks.
                    const dx = flydownWidth - margin - scale * (this.tabWidth_ - blockXY.x);
                    block.moveBy(dx, 0);
                    blockXY.x += dx;
                }
                if (block.flyoutRect_) {
                    block.flyoutRect_.setAttribute('width', blockHW.width);
                    block.flyoutRect_.setAttribute('height', blockHW.height);
                    block.flyoutRect_.setAttribute('x',
                        this.RTL ? blockXY.x - blockHW.width : blockXY.x);
                    block.flyoutRect_.setAttribute('y', blockXY.y);
                }
            })
            // console.log('flydownWidth, flydownHeight', flydownWidth, flydownHeight);
            // Record the width for us in showAt method
            this.width_ = flydownWidth - 7 * scale;
            this.height_ = flydownHeight - 14 * scale;
        }
    }

    shouldHide = true;

    hide() {
        if (this.shouldHide) {
            super.hide();
            VmtFieldFlyoutText.openFieldFlyout_ = null;
        }
        this.shouldHide = true;
    }

    autoHide() {
        // this.shouldHide = true;
        // super.autoHide();
        this.hide();
    }
}